import { Injectable } from '@angular/core';


@Injectable()
export class CustomvalidationService {

  constructor() { }
   

  	

}



// WEBPACK FOOTER //
// ./src/app/authentication/customvalidation.service.ts